import type { ButtonProps, CircularProgressProps } from '@mui/material';

export const translateColor = (color: ButtonProps['color']): CircularProgressProps['color'] => {
  if (color as any === 'grey') {
    return 'primary';
  }

  if (color as any === 'secondary_dark') {
    return 'secondary';
  }

  return color;
};
